import "./VideoContainer.scss";
import React from "react";
import { MdZoomOutMap } from "react-icons/md";
import { StateSetter } from "../utils/types";

import { Card } from "react-bootstrap";
import { Button, ButtonType, ButtonFrameworkVariant, Spinner, Video } from "../Components";
import { VideoInfo } from "./videoTutorialUtils";
interface VideoContainerProps {
  videoContent: VideoInfo | undefined;
  currentVideo?: VideoInfo | undefined;
  setFullScreenVideo: StateSetter<boolean>;
  onFullScreenClick: (video: VideoInfo) => void;
}

const VideoContainer = ({
  videoContent,
  setFullScreenVideo,
  onFullScreenClick = () => {},
}: VideoContainerProps): JSX.Element => {
  if (videoContent?.videoFile) {
    return (
      <Card className="videoContainer">
        <div className="videoContentContainer">
          <Card.Header className="videoContainerHeader">{videoContent.title}</Card.Header>
          {videoContent.content ? (
            <h3 className="videoContainerTextBox">{videoContent.content}</h3>
          ) : null}
          {videoContent.uploadDate ? (
            <h4 className="videoContainerSmallText">{`Uploaded: ${videoContent.uploadDate}`}</h4>
          ) : null}
          {videoContent.videoCreator ? (
            <h4 className="videoContainerSmallText">{`Video Creator: ${videoContent.videoCreator}`}</h4>
          ) : null}
          <div className="innerVideoContainer">
            <Video
              src={videoContent.videoFile}
              controls
              className="videoSpecs"
              poster={videoContent.thumbnailFile}
              unloader={<Spinner size={20} />}
            ></Video>
          </div>
        </div>
        <Button
          className="videoContainerButton"
          type={ButtonType.OUTLINED}
          variant={ButtonFrameworkVariant.LEADING_ICON}
          icon={<MdZoomOutMap />}
          onClick={() => {
            onFullScreenClick(videoContent);
            setFullScreenVideo(true);
          }}
        >
          Watch Tutorial Fullscreen
        </Button>
      </Card>
    );
  } else {
    return (
      <Card className="videoContainer">
        <div className="videoContentContainer">
          <Card.Header className="videoContainerHeader">No Content Available</Card.Header>{" "}
        </div>
        <div className="innerVideo"></div>
        <Button
          className="videoContainerButton"
          type={ButtonType.OUTLINED}
          variant={ButtonFrameworkVariant.LEADING_ICON}
          icon={<MdZoomOutMap />}
        >
          Watch Tutorial Fullscreen
        </Button>
      </Card>
    );
  }
};

export default VideoContainer;
